import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import i18next from 'i18next';

import { ContentService, GroupingsService } from '../../services';
import { Message } from "../Message";

import config from "config";

class GroupingImage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            imageName: this.props.imageName,
            groupingId: this.props.groupingId,
            showImageModal: false,
            showAddImageModal: false, 
            loading: true
        }
    }

    componentDidMount() {
        this.getImage();
    }

    toggleShowImageModal() {
        this.setState({
          showImageModal: !this.state.showImageModal
        });
    }

    toggleShowAddImageModal() {
        this.setState({
          showAddImageModal: !this.state.showAddImageModal
        });
    }

    getImage() {
        if (this.state.imageName) {
          const {groupingId, imageName} = this.state;
          ContentService.getDeviceGroupingImage(groupingId, imageName).then((response) => {
              this.setState({imgSrc: response, loading: false});
          }).catch(err => {
              console.error(err);
              this.setState({loading: false})
          });
        } else {
          this.setState({loading: false});
        }
    }

    onUploadDrop(file) {
        GroupingsService.uploadImage(this.state.groupingId, file[0]).then(response => {
          this.setState({imageName: response.data.stringValue}, () => this.getImage());
        }).catch(error => {
          this.setState({ localErrorMessage: i18next.t('messages.error-uploading-image') });
          console.error(error);
        });

        this.toggleShowAddImageModal();
    }
    
    deleteImage() {
      const { groupingId, imageName } = this.state;
        GroupingsService.deleteImage(groupingId, imageName).then(response => {
            this.setState({imgSrc: null, imageName: null});
        }).catch(error => {
            console.error(error);
        });
    }

    messageDismissCallback() {
      this.setState({localErrorMessage: null});
    }

    renderMessages() {
      if (this.state.localErrorMessage) {
        return (
          <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
        );
      }
  
      return null;
    }

    render() {
      if (this.state.loading) {
          return (
            <div className="loader">{i18next.t('loading')}</div>
        );
      } else {
        return (
          <div>
              <div className="metadata-inner">
                  {this.state.imgSrc ? 
                  <div>
                    <div className="device-image-container group-image">
                        <img className="device-image-in-situ"  src={this.state.imgSrc} onClick={this.toggleShowImageModal.bind(this)} />
                        <img className="device-image-zoom" src={`${config.WEB_BASE_URL}/images/icon/enlarge.svg`} />
                    </div>
                    <div className="device-image-buttons">
                        <Button className="btn btn-sm btn-default " onClick={this.toggleShowAddImageModal.bind(this)}>{i18next.t('replace-image')}</Button>
                        &nbsp;
                        <Button className="btn btn-sm btn-default red" onClick={this.deleteImage.bind(this)}>{i18next.t('delete-image')}</Button>
                      </div>
                  </div>
                  :
                  <div>
                    <div className="no-image-found-box"><img src={`${config.WEB_BASE_URL}/images/icon/no_image_icon.svg`} /> <br/> <em>{i18next.t('no-image-found')}</em></div>
                    <Button className="btn btn-sm btn-default" onClick={this.toggleShowAddImageModal.bind(this)}>{i18next.t('add-image')}</Button>
                  </div>
                  }
              </div>
              
              {this.renderMessages()}
  
              <Modal show={this.state.showAddImageModal} onHide={this.toggleShowAddImageModal.bind(this)}>
              <Modal.Header closeButton>
                <Modal.Title>{i18next.t('image')}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="device-dropzone">
                  <Dropzone className="dropzone-format" onDrop={(files) => this.onUploadDrop(files)}>
                    <div style={{textAlign: "center", top: "45%", position: "relative"}}> {i18next.t('pages.groups.drag-drop-image')} </div>
                    <button  style = {{margin: "0 auto", display: "block", position: "relative", top: "110px"}} className="btn btn-sm btn-default"> {i18next.t('upload-an-image')} </button>
                  </Dropzone>
                </div>
              </Modal.Body>
            </Modal>
  
            <Modal dialogClassName="devices" show={this.state.showImageModal} onHide={this.toggleShowImageModal.bind(this)}>
              <Modal.Header closeButton>
                <Modal.Title>{i18next.t('image')}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <img src={this.state.imgSrc} alt={i18next.t('image')} />
                </div>
              </Modal.Body>
            </Modal>
          </div>
          )
      }
    }    
}

export default GroupingImage;